import { Box, Flex, FlexProps } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { SideNavBar } from 'src/components/templates/Sidebar';
import { useFilterContext } from 'src/contexts/FilterContext';
import { InitialModelLoadingScreen } from 'src/components/templates/InitialModelLoadingScreen';
import { useAppContext } from 'src/contexts/AppContext';

export const NavBarLayout: React.FC<FlexProps> = (props) => {
  const { currentAppService, modelVersionsState } = useFilterContext();
  const { subscriptionLevels } = useAppContext();

  const shouldShowInitialModelLoader = useMemo(() => {
    if (!currentAppService) {
      return false;
    }

    const serviceIsEnabled = Boolean(subscriptionLevels[currentAppService]);

    if (!serviceIsEnabled) {
      return false;
    }

    if (modelVersionsState.isError) {
      return false;
    }

    if (modelVersionsState.isLoading) {
      return true;
    }

    return modelVersionsState.modelVersions.length === 0;
  }, [currentAppService, modelVersionsState, subscriptionLevels]);

  return (
    <SideNavBar>
      <Flex
        direction="column"
        align="flex-start"
        wrap="wrap"
        minH="100vh"
        w="100%"
        bg="surface.page"
        className="page-wrapper"
        {...props}>
        <Flex direction="column" w="100%" minH="100vh">
          <Box
            flex="1"
            bg="surface.panel"
            borderRadius="lg"
            borderWidth="1px"
            borderColor="surface.border"
            overflow="hidden"
            m={{ base: 2, lg: 4 }}
            ml={{ base: 2, lg: 0 }}
            alignSelf="stretch">
            <Flex className="content-wrapper" flex="1" w="100%">
              {shouldShowInitialModelLoader ? (
                <InitialModelLoadingScreen currentService={currentAppService} />
              ) : (
                props.children
              )}
            </Flex>
          </Box>
        </Flex>
      </Flex>
    </SideNavBar>
  );
};
